<template lang="">
  <div>
    <b-card no-body>
      <b-card-header>
        <h4 class="mb-0">
          Einnahmen
        </h4>
        <b-card-text class="font-medium-5 mb-0">
          <feather-icon
            icon="HelpCircleIcon"
            size="21"
            class="text-muted cursor-pointer"
          />
        </b-card-text>
      </b-card-header>

      <!-- apex chart -->

      <b-row class="text-center mx-0">
        <b-col
          xl="4"
          md="4"
          sm="6"
          class="border-top border-right d-flex align-items-between flex-column py-1"
        >
          <statistic-card-vertical
            color="success"
            icon="DollarSignIcon"
            :statistic="getRevenueTillNow()"
            statistic-title="Gesamt"
          />
        </b-col>

        <b-col
          xl="4"
          md="4"
          sm="6"
          class="border-top border-right d-flex align-items-between flex-column py-1"
        >
          <statistic-card-vertical
            color="success"
            icon="DollarSignIcon"
            :statistic="getSumOfAllActiveOrderItems()"
            statistic-title="Aktueller Monat"
          />
        </b-col>

        <b-col
          xl="4"
          md="4"
          sm="6"
          class="border-top d-flex align-items-between flex-column py-1"
        >
          <statistic-card-vertical
            color="success"
            icon="DollarSignIcon"
            :statistic="getTotalSumOfAllStoragesAndOffers()"
            statistic-title="Chance (aktive Angebote)"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-card
      no-body
      style="height: 500px"
    >
      <b-card-header>
        <h4 class="mb-0">
          Umsatz und Lager vermietet - 12 Monate
        </h4>
      </b-card-header>
      <BarChartLastTwelveMonths />
    </b-card>
  </div>
</template>

<script>
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import {
  BCard,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BRow,
} from 'bootstrap-vue'
import businessMetrics from '@/helper/businessMetrics'
import BarChartLastTwelveMonths from './BarChartRevenueLastTwelveMonths.vue'

export default {
  setup() {
    const {
      getSumOfAllActiveOrderItems,
      getRevenueTillNow,
      getTotalSumOfAllStoragesAndOffers,
      getSumOfAllActiveOrderItemsTillMoveoutdate,
      getSumOfAllActiveOrderItemsTillToday,
      getOrderItemsMonthlyRevenue,
    } = businessMetrics()

    return {
      getSumOfAllActiveOrderItems,
      getRevenueTillNow,
      getTotalSumOfAllStoragesAndOffers,
      getSumOfAllActiveOrderItemsTillMoveoutdate,
      getSumOfAllActiveOrderItemsTillToday,
      getOrderItemsMonthlyRevenue,
    }
  },

  components: {
    BarChartLastTwelveMonths,
    StatisticCardVertical,
    BCard,
    BRow,
    BCol,
    BCardText,
    BCardTitle,
    BCardHeader,
  },
}
</script>

<style scoped></style>
